import React, { HTMLAttributes, ReactElement } from 'react';
import classNames from 'classnames';
import Icon from 'atomic/icon/icon';

import './main-rankings-button.scss';

interface MainRankingsButton extends HTMLAttributes<HTMLButtonElement> {
    direction: 'left' | 'right';
}

const MainRankingsButton: React.FC<MainRankingsButton> = ({ onClick, direction }): ReactElement => {
    const classes = classNames('main-rankings-button', `main-rankings-button__${direction}`);

    return (
        <button type="button" className={classes} onClick={onClick}>
            <Icon icon={`chevron-${direction}`} />
        </button>
    );
};

export default MainRankingsButton;
